export default [
  {
    path: '/pvh/order/list',
    name: 'PvhOrderList',
    component: () => import('@/views/Pvh/PvhOrderList.vue')
  },
  {
    path: '/pvh/order/update/:id',
    name: 'PvhOrderUpdate',
    component: () => import('@/views/Pvh/PvhOrderUpdate.vue'),
    redirect: {
      name: 'PvhOrderUpdate_comment'
    },
    children: [
      {
        path: 'comment',
        name: 'PvhOrderUpdate_comment',
        component: () => import('@/components/pvh/PvhOrderUpdateComment')
      },
      {
        path: 'main',
        name: 'PvhOrderUpdate_main',
        component: () => import('@/components/pvh/PvhOrderUpdateMain')
      },
      {
        path: 'objects',
        name: 'PvhOrderUpdate_object',
        component: () => import('@/components/pvh/PvhOrderUpdateObject')
      },
      {
        path: 'costs',
        name: 'PvhOrderUpdate_cost',
        component: () => import('@/components/pvh/PvhOrderUpdateCost')
      },
      {
        path: 'coming',
        name: 'PvhOrderUpdate_coming',
        component: () => import('@/components/pvh/PvhOrderUpdateComing')
      },
      {
        path: 'contact',
        name: 'PvhOrderUpdate_contact',
        component: () => import('@/components/pvh/PvhOrderUpdateContact')
      }
    ]
  }
]
